import { AppService } from "./app.service";
import { Router } from "@angular/router";
var AuthguardGuard = (function () {
    function AuthguardGuard(appService, router) {
        this.appService = appService;
        this.router = router;
    }
    AuthguardGuard.prototype.canActivate = function () {
        if (this.appService.getCurrentUser() != null) {
            return true;
        }
        else {
            this.router.navigate(['login']);
        }
        return false;
    };
    return AuthguardGuard;
}());
export { AuthguardGuard };



// WEBPACK FOOTER //
// /build/client-cms/src/app/authguard.guard.ts.pre-build-optimizer.js